import Vue from 'vue'
import Vuex from 'vuex'

import account from './modules/account'
import setting from './modules/setting'
import report from './modules/report'
import holiday from './modules/holiday'
import * as actions from './actions'
import * as getters from './getters'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  strict: debug,
  modules: {
    account,
    setting,
    report,
    holiday,
  },
  actions,
  getters,
})



// WEBPACK FOOTER //
// ./src/store/index.js